module.exports = __webpack_public_path__ + "img/customer_shjd.8985fdaf.svg";